export default __webpack_public_path__ + "static/media/serviceBlock2.634d4363.jpeg";